<script>
  import Container from '@/Elements/Containers/FullCentred.svelte'; 
  import Meta from '@/Elements/Signals/Dark/Meta/XSmall.svelte';
  import Title from '@/Elements/Signals/Dark/Title.svelte';
  import Para from '@/Elements/Signals/Dark/Para.svelte';
  import Grid from '@/Elements/Grids/Open.svelte';
  import Preview from '@/Elements/Shapes/Cards/Preview.svelte';
  import Header from '@/Elements/Signals/Dark/Headers/Base.svelte';
  import Text from '@/Elements/Signals/Dark/Text/Small.svelte';

  export let scope;

  let meta = scope.meta;
  let title = scope.title;
  let text = scope.text;
  let options = scope.options;
  
</script>

<style></style>

<section id="tech" class="pt-12 pb-24 bg-gray-50">
  <Container>
    <div class="px-var space-y-3 py-6">
      <div class="space-y-1">
        <Meta>{meta}</Meta>
        <Title>{title}</Title>
      </div>
      <Para>{text}</Para>
    </div>
    <div class="px-var py-3">
      <Grid>
        {#each options as option}
          <div class="">
            <div class="space-y-6">
              <Preview item={option.img}></Preview>
              <div class="space-y-3">
                <Header>{option.title}</Header>
                <Text>{option.text}</Text>
                <div class="flex flex-col space-y-2 xl:flex-row xl:space-y-0 justify-between">
                  {#if option.ghg}
                  <div class="flex items-center">
                    <div class="w-5 h-5 text-green-900 mr-2">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                      </svg>
                    </div>
                    <span class="text-gray-600 opacity-60 text-xs font-bold underline hover:text-gray-900">
                      <a href="https://greenhomesgrant.campaign.gov.uk/" target="_blank" rel="noreferre noopener">
                        Green Homes Grant
                      </a>
                    </span>
                  </div>
                  {/if}
                  {#if option.rhi}
                  <div class="flex items-center">
                    <div class="w-5 h-5 text-yellow-900 mr-2">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                      </svg>
                    </div>
                    <span class="text-gray-600 opacity-60 text-xs font-bold underline hover:text-gray-900">
                      <a href="https://www.ofgem.gov.uk/environmental-programmes/domestic-rhi" target="_blank" rel="noreferrer noopener">
                        Renewable Heat Incentive
                      </a>
                    </span>
                    </div>
                  {/if}
                  {#if option.hub.active}
                  <div class="flex items-center">
                    <div class="w-5 h-5 text-red-900 mr-2">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5" />
                      </svg>
                    </div>
                    <span class="text-gray-600 opacity-60 text-xs font-bold underline hover:text-gray-900">
                      <a href={ option.hub.link }>
                        { option.hub.key }
                      </a>
                    </span>
                    </div>
                  {/if}
                </div>
              </div>
            </div>
          </div>
        {/each}
      </Grid>
    </div>
  </Container>
</section>